"use client";

import React from "react";
import { motion } from "framer-motion";
import { 
  Building2, 
  Handshake, 
  Target, 
  Globe, 
  Lightbulb,
  Briefcase,
  ArrowRight
} from "lucide-react";
import { Button } from "../../../components/ui/button";
import Link from "next/link";

const PartnerPage = () => {
  return (
    <div className="bg-white min-h-screen font-jakarta">
      {/* Title */}
      <section className="py-24 px-6 text-center">
        <motion.div
           initial={{ opacity: 0, y: 20 }}
           animate={{ opacity: 1, y: 0 }}
           className="max-w-4xl mx-auto space-y-8"
        >
          <div className="flex justify-center">
            <div className="bg-[#063258] p-4 rounded-3xl">
              <Handshake className="w-12 h-12 text-[#FFAE00]" />
            </div>
          </div>
          <h1 className="text-5xl md:text-7xl font-bricolage font-bold text-[#063258]">
            Partner with <span className="text-[#FFAE00]">Impact.</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Collaborate with Outcome Outing to reach a niche community of creators, founders, and future leaders through immersive experiences.
          </p>
        </motion.div>
      </section>

      {/* Collaboration Types */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Brand Partnerships */}
          <div className="bg-gray-50 p-12 rounded-[3rem] border border-gray-100 flex flex-col justify-between hover:border-[#FFAE00]/30 transition-all">
            <div className="space-y-6">
              <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm">
                <Target className="w-8 h-8 text-[#063258]" />
              </div>
              <h3 className="text-3xl font-bricolage font-bold text-[#063258]">Brand Partnerships</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                Integrate your products naturally into our trip experiences. From gear and gadgets to lifestyle brands, we provide context-rich product placements and authentic stories.
              </p>
            </div>
            <Link href="mailto:partners@outcomeouting.com" className="mt-10">
              <Button className="bg-[#063258] text-white rounded-xl px-8 py-4 font-bold">Inquire Now</Button>
            </Link>
          </div>

          {/* Corporate Retreats */}
          <div className="bg-[#063258] p-12 rounded-[3rem] text-white flex flex-col justify-between shadow-2xl shadow-[#063258]/20">
            <div className="space-y-6">
              <div className="bg-white/10 w-16 h-16 rounded-2xl flex items-center justify-center border border-white/20">
                <Briefcase className="w-8 h-8 text-[#FFAE00]" />
              </div>
              <h3 className="text-3xl font-bricolage font-bold">Corporate Retreats</h3>
              <p className="text-lg opacity-80 leading-relaxed">
                Reimagine your team outings. We design custom outcome-driven offsites focusing on team-building, strategy pivots, and employee well-being in inspiring locations.
              </p>
            </div>
            <Link href="https://wa.me/917982579691" target="_blank" className="mt-10">
              <Button className="bg-[#FFAE00] text-white rounded-xl px-8 py-4 font-bold border-none hover:bg-orange-500">Book Offsite</Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Stats/Why Us */}
      <section className="py-24 px-6 bg-gray-50 border-y border-gray-100">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bricolage font-bold text-center mb-16 text-[#063258]">Why Collaborate?</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { val: "20k+", label: "Target Audience" },
              { val: "90%", label: "Retention Rate" },
              { val: "100+", label: "Brand Stories" },
              { val: "50+", label: "Active Mentors" }
            ].map((stat, i) => (
              <div key={i} className="space-y-2 translate-none">
                <p className="text-4xl md:text-5xl font-bricolage font-bold text-[#FFAE00]">{stat.val}</p>
                <p className="text-gray-500 font-bold uppercase text-sm tracking-widest">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-6 text-center max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bricolage font-bold text-[#063258] mb-8">Building the future of experiential travel. Together.</h2>
        <p className="text-xl text-gray-500 mb-12">
          If your values align with growth, intentionality, and adventure, we definitely need to talk.
        </p>
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Link href="mailto:partnerships@outcomeouting.com" target="_blank">
            <Button className="bg-[#063258] hover:bg-[#0D0D0D] text-white px-10 py-7 rounded-2xl text-xl font-bold shadow-xl flex items-center gap-2">
              Email Partnerships <ArrowRight className="w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default PartnerPage;
